/*********************
 ESL (English as a Second Language) Rule
 *********************/
import Rule from '../Rule';
import {ruleTypes} from '../../../constants';
import {buildLogForRule} from "../../../utils/logUtils";

export default class ESLRule extends Rule {
  constructor(logic) {
    super([], logic);
    this.ruleType = ruleTypes.ESL;
  }

  run(state) {
    const {isESL} = state;
    const meetsRuleCondition = this.logic(isESL);
    return {
      stateMeetsRuleCondition: meetsRuleCondition,
      decisionContext: {[(this.ruleType + '_' + meetsRuleCondition)]: 'isESL:' + isESL},
      log: buildLogForRule(this, state, meetsRuleCondition, {isESL}),
    }
  }
}
